class SlideshowFade {
  constructor(container) {
    this.container = container;
    this.slides = Array.from(container.querySelectorAll('.slideshow__slide'));
    this.prevBtn = container.querySelector('.slideshow__prev');
    this.nextBtn = container.querySelector('.slideshow__next');
    this.dots = Array.from(container.querySelectorAll('.slideshow__dot'));
    this.currentIndex = 0;
    this.timer = null;

    // 初期表示
    this.showSlide(this.currentIndex);

    // 自動スライド
    this.startAutoSlide();

    // イベント
    this.prevBtn?.addEventListener('click', () => this.prevSlide());
    this.nextBtn?.addEventListener('click', () => this.nextSlide());
    this.dots.forEach(dot =>
      dot.addEventListener('click', e => {
        const i = parseInt(e.currentTarget.dataset.index);
        this.goToSlide(i);
      })
    );
  }

  showSlide(index) {
    this.slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === index);
    });
    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === index);
    });
  }

  nextSlide() {
    this.currentIndex = (this.currentIndex + 1) % this.slides.length;
    this.showSlide(this.currentIndex);
    this.restartAutoSlide();
  }

  prevSlide() {
    this.currentIndex =
      (this.currentIndex - 1 + this.slides.length) % this.slides.length;
    this.showSlide(this.currentIndex);
    this.restartAutoSlide();
  }

  goToSlide(index) {
    this.currentIndex = index;
    this.showSlide(this.currentIndex);
    this.restartAutoSlide();
  }

  startAutoSlide() {
    this.timer = setInterval(() => this.nextSlide(), 5000); // 5秒ごと
  }

  restartAutoSlide() {
    clearInterval(this.timer);
    this.startAutoSlide();
  }
}

// 初期化
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-slideshow]').forEach(el => new SlideshowFade(el));
});
